import { atom } from 'recoil';
import { userDomain } from '@user';
import { editableFormStateKay } from '../constants';

export const editableFormState = atom<userDomain.EditableForm | null>({
  key: editableFormStateKay,
  default: null,
});
